<template>
    <div class="sensitiveOperationVer">
        <el-dialog
                :title="$t('message.safetyVerification')"
                :visible.sync="isShowDialog"
                width="400px"
                custom-class="sensitiveDialog">
            <div class="sensitiveWrap">
                <table class="sensitiveTab">
                    <tr>
                        <td>{{$t('message.waysOfIdentifying')}}</td>
                        <td>
                            <el-select v-model="verificationSel" size="mini">
                                <el-option
                                        v-if="verificationWay.mobile === '1'"
                                        :label="$t('message.SMSVerification')"
                                        value="mobile">
                                </el-option>
                                <el-option
                                        v-if="verificationWay.email === '1'"
                                        :label="$t('message.emailVerification')"
                                        value="email">
                                </el-option>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>
                            <el-button v-if="!countdown"
                                       size="mini"
                                       @click="sendCode">{{$t('message.getVerificationCode')}}</el-button>
                            <el-button v-else
                                       size="mini"
                                       :disabled="true">{{verificationSecond}}{{$t('message.retryInSeconds')}}</el-button>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('message.verificationCode')}}</td>
                        <td>
                            <el-input v-model.trim="verCode" size="mini"></el-input>
                        </td>
                    </tr>
                </table>
                <div class="btnBox">
                    <el-button size="mini"
                               type="success"
                               @click="verificationCode">{{$t('message.verification')}}</el-button>
                    <el-button size="mini"
                               type="danger"
                               style="margin-left: 50px;"
                               @click="isShowDialog=false">{{$t('message.cancel')}}
                    </el-button>
                </div>
            </div>
            <SJMLoading v-if="isShowLoading" top="50%"></SJMLoading>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'SensitiveOperationVer',// 敏感操作验证
        props: {
            // 显示组件
            show: {
                type: Number,
                default: -1
            },
            // 验证完毕回调
            callback: {
                type: Function,
                default: () => {
                }
            }
        },
        data() {
            return {
                isShowDialog: false,// 显示组件
                // 有哪些验证方法
                verificationWay: {
                    email: '0',// 邮箱 0-未绑定、1-已绑定
                    mobile: '0'// 手机 0-未绑定、1-已绑定
                },
                verificationSel: '',// 用户选择的验证方式
                verCode: '',// 验证码
                isShowLoading: true,// 是否显示加载中
                emailSendCount: 1,// 邮箱发送次数
                verificationTimer: null,// 验证码倒计时定时器
                verificationSecond: 60,// 倒计时秒数
                countdown: false// 是否倒数
            };
        },
        watch: {
            // prop显示组件
            show() {
                // 发生变动即打开弹窗
                this.isShowDialog = true;
            },
            // 显示组件
            isShowDialog(newValue) {
                if (newValue) {
                    // 判断是否已通过敏感验证
                    if (this.$getCookie('accVerification') && sessionStorage.accVerification) {
                        this.isShowDialog = false;// 关闭组件
                        this.callback();// 执行回调
                    }
                } else {
                    clearInterval(this.verificationTimer);// 初始化定时器
                    this.countdown = false;// 结束倒数
                    this.verificationSecond = 60;// 初始化倒计时
                    this.verCode = '';// 初始化输入的验证码
                    this.emailSendCount = 1;// 邮箱发送次数
                }
            }
        },
        created() {
            this.getAccountVerificationWay();// 获取当前登录账户有哪些验证方法
        },
        methods: {
            // 获取当前登录账户有哪些验证方法
            getAccountVerificationWay() {
                this.$ajax({
                    url: '/personalCenterHandler/common/PersonalCenterCommonHandler.ashx',
                    data: {
                        act: 'getAccountVerificationWay'// 获取当前登录账户有哪些验证方法
                    },
                    success: (res) => {
                        // 赋值验证方法
                        this.verificationWay = res.success.verificationWay;
                        // 隐藏加载中
                        this.isShowLoading = false;
                    }
                });
            },
            // 发送验证码
            sendCode() {
                this.$ajax({
                    url: '/personalCenterHandler/common/PersonalCenterCommonHandler.ashx',
                    data: {
                        act: 'getVerificationCodeData',// 当前登录账户获取验证码
                        method: this.verificationSel,// email-邮箱、mobile-手机
                        emailSendCount: String(this.emailSendCount)// 邮箱验证发送次数
                    },
                    beforeSend: () => {
                        this.countdown = true;// 开始倒数
                    },
                    errCallback: () => {
                        this.countdown = false;// 结束倒数
                    },
                    success: () => {
                        // 倒计时
                        this.verificationTimer = setInterval(() => {
                            if (this.verificationSecond === 0) {
                                clearInterval(this.verificationTimer);
                                this.countdown = false;// 结束倒数
                                this.verificationSecond = 60;// 初始化倒计时
                                return;
                            }
                            this.verificationSecond--;
                        }, 1000);
                    },
                    complete: () => {
                        // 邮箱验证次数++
                        if (this.verificationSel === 'email') {
                            this.emailSendCount++;
                        }
                    }
                });
            },
            // 验证验证码
            verificationCode() {
                this.$ajax({
                    url: '/personalCenterHandler/common/PersonalCenterCommonHandler.ashx',
                    data: {
                        act: 'postVerificationCodeData',// 当前登录账户验证验证码
                        method: this.verificationSel,// email-邮箱、mobile-手机
                        verificationCode: this.verCode// 验证码
                    },
                    success: (res) => {
                        // 敏感验证有效期6小时&&不关闭浏览器
                        this.$setCookie('accVerification', res.success.cookie, 0.25);
                        sessionStorage.accVerification = res.success.cookie;
                        this.isShowDialog = false;// 关闭验证组件
                        this.callback();// 执行回调
                    }
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .sensitiveOperationVer {
        /deep/ .sensitiveDialog {
            position: absolute;
            top: 45%;
            left: 50%;
            margin-top: 0 !important;
            transform: translate(-50%, -50%);

            .el-dialog__body {
                padding: 0 20px 20px;
            }

            .sensitiveTab {
                tr {
                    height: 35px;
                }

                td:nth-child(1) {
                    padding-right: 20px;
                    text-align: right;
                }

                td:nth-child(2) {
                    text-align: left;
                }
            }

            .btnBox {
                display: flex;
                justify-content: center;
                margin-top: 20px;
            }
        }
    }
</style>
